import { defineComponent } from "vue";
export default defineComponent({
    name: 'SymbolCheck',
    props: {
        preventAnimation: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            default: '#336600'
        },
        strokeColor: {
            type: String,
            default: '#DEFFB8'
        },
    },
    computed: {
        cssClasses() {
            const classes = [];
            if (this.preventAnimation) {
                classes.push('preventAnimation');
            }
            return classes.join(' ');
        }
    }
});
